
import { Channel } from "../stats/channel";
import { Rooftop } from "../rooftop";

export class updateRooftops {
    rooftops: Array<Rooftop>;
    channels: Array<Channel>;
    constructor(rooftops,channels){
        this.rooftops = rooftops;
        this.channels = channels;
    }
}


// WEBPACK FOOTER //
// ./src/app/components/class/broadcaster/update-rooftops.ts